
const getAttribute = (target,data)=>{
    const logic = target.getAttribute(`data-${data}`)
    return logic
}

export default getAttribute